import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';

import {
  AppButton,
  AppDropdown,
  AppInput,
} from '../../../shared/forms/components';
import { notificationActions } from '../../../app/redux/notification.slice';
import { getUserList } from '../../../app/redux/appSelector';
import { RootState } from '../../../app/redux/rootReducer';
import { Section } from '../../../models/section';
import { updateSection } from '../../../services/api/sectionApi';

const getInitialValues = (section: Section) => ({
  ...section,
});

const validationSchema = Yup.object().shape({
  sectionName: Yup.string().required('This is a required field'),
  responsibleUserId: Yup.string().required('This is a required field'),
});

interface Props {
  categoryId: string;
  section: Section;
  handleModalToggle?: () => void;
  setSection?: (section: Section) => void;
}

const EditSectionForm: React.FC<Props> = ({
  categoryId,
  section,
  handleModalToggle,
  setSection,
}: Props) => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state);
  const [isLoading, setIsLoading] = useState(false);
  const users = getUserList(state);

  const getUsersOptions = () =>
    users.map((user) => (
      <option key={user.userId} value={user.userId}>
        {user.email}
      </option>
    ));

  const onSubmitHandler = (values: Section) => {
    setIsLoading(true);
    updateSection(categoryId, values).subscribe(
      (response: Section) => {
        dispatch(
          notificationActions.setToast({
            severity: 'success',
            message: 'Successfully Updated Section',
            title: 'Success',
          })
        );
        handleModalToggle && handleModalToggle();
        setSection && setSection(response);
      },
      (err: Error) => {
        dispatch(
          notificationActions.setToast({
            severity: 'danger',
            message: err.message,
            title: 'Error: Failed To Update Section',
          })
        );
        setIsLoading(false);
      }
    );
  };

  return (
    <Formik
      initialValues={getInitialValues(section)}
      onSubmit={onSubmitHandler}
      validationSchema={validationSchema}
    >
      {({ setFieldValue, values }) => (
        <Form>
          <AppInput
            name="sectionName"
            label="Section Name*"
            placeholder="Enter Section Name"
            type="text"
            loading={isLoading}
          />
          <AppDropdown
            name="responsibleUserId"
            label="Responsible User"
            placeholder="Responsible User"
          >
            <option defaultChecked value="">
              Unassigned
            </option>
            {getUsersOptions()}
          </AppDropdown>
          <AppButton type="submit" text="Update" loading={isLoading} />
        </Form>
      )}
    </Formik>
  );
};

export default EditSectionForm;
